import { getCookie } from "../utils/functions";

export const authHeader =  () => {
    const token = getCookie("dc-auth");
    if (token) {
        return {
            Authorization: `Bearer ${token}`,
        };
    }
    return {};
};
